const productData = [
  {
    id: 1,
    name: "Food Enrichment Lick Pad Small",
    category: "Lick Mats",
    price: "4.99",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.jpg",
    images: ["/img/101.jpg"],
    size: ["S", "M"],
    colors: ["Indigo", "Light Blue"],
    material: "Food-grade silicone, BPA-Free",
    description: [
      "Compact lick pad with textured surface designed to extend mealtime and soothe stress in dogs.",
      "Perfect for spreading with peanut butter, yogurt, wet food, or treats to keep your pet occupied.",
      "Anti-slip base ensures the mat stays securely in place during enthusiastic licking sessions.",
      "Dishwasher safe (top rack) for easy and convenient cleaning after each use.",
      "Promotes slower eating habits, reducing anxiety and improving digestion in dogs.",
      "Ideal for calming anxious pets during thunderstorms, fireworks, or alone time.",
      "Lightweight and portable, perfect for travel or vet visits.",
    ],
    Features: [
      "Textured surface for longer licking sessions",
      "Secure anti-slip grip base",
      "Made from food-safe, BPA-free silicone",
      "Dishwasher safe (top rack)",
      "Suitable for dogs of all sizes",
      "Freezer safe for frozen treats",
      "Promotes mental stimulation",
    ],
  },
  {
    id: 2,
    name: "Food Enrichment Lick Mat Large",
    category: "Lick Mats",
    price: "7.99",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.jpg",
    images: ["/img/102.jpg"],
    size: ["M", "L"],
    colors: ["Deep Red", "Charcoal"],
    material: "Food-grade silicone, BPA-Free",
    description: [
      "Large-format lick mat designed for extended feeding sessions and maximum enrichment.",
      "Deep grooves and advanced textures provide an engaging licking experience to keep dogs entertained.",
      "Ideal for freezing with treats to provide longer-lasting mental stimulation on hot days.",
      "Multiple texture zones offer varying difficulty levels for progressive enrichment.",
      "Promotes healthy eating pace and significantly reduces anxiety during alone time.",
      "Durable construction withstands chewing and daily use.",
      "Great tool for slow feeding and portion control.",
    ],
    Features: [
      "Large surface area for extended use",
      "Advanced multi-zone textured pattern",
      "Food-grade silicone, completely safe for pets",
      "Can be used with wet, frozen, or spreadable treats",
      "Easy to clean, dishwasher safe",
      "Anti-slip base for stability",
      "Promotes calm behavior",
    ],
  },
  {
    id: 3,
    name: "Food Enrichment 2-IN-1 Mini Slow Feeder & Lick Pad",
    category: "Slow Feeders",
    price: "9.99",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.jpg",
    images: ["/img/103.jpg"],
    size: ["One size"],
    colors: ["Olive", "Mulberry"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Innovative 2-in-1 design combining a slow feeder bowl with an integrated lick pad.",
      "Dual functionality allows for both dry kibble and wet treat dispensing simultaneously.",
      "Compact size perfect for small to medium dogs or for convenient travel purposes.",
      "Encourages natural foraging behavior and significantly slows down eating pace.",
      "Durable construction with rounded edges ensures safe use for all pets.",
      "Helps reduce bloating and improves digestion through slower eating.",
      "Adjustable design can be used as separate pieces or combined together.",
    ],
    Features: [
      "2-in-1 design: slow feeder and lick pad combined",
      "Adjustable difficulty levels for progressive training",
      "Food-safe and BPA-Free materials",
      "Dishwasher safe for easy cleaning",
      "Compact size ideal for travel",
      "Suitable for indoor and outdoor use",
      "Promotes healthy eating habits",
    ],
  },
  {
    id: 4,
    name: "Food Enrichment Slow Feeding Plate Easy",
    category: "Slow Feeders",
    price: "12.99",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.jpg",
    images: ["/img/104.jpg", "/img/104b.jpg"],
    size: ["S", "M", "L"],
    colors: ["Mulberry", "Tan"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Interactive slow feeding plate that turns mealtime into a fun and engaging puzzle experience.",
      "Multiple ridges and valleys throughout the design slow down eating and promote healthy digestion.",
      "Easy difficulty level perfect for beginners or dogs new to enrichment feeding toys.",
      "Dishwasher safe for convenient and thorough cleaning after every meal.",
      "Non-slip base ring keeps the plate securely in place during enthusiastic eating.",
      "Available in multiple sizes to accommodate different dog breeds and appetites.",
      "Encourages natural licking and foraging instincts in your pet.",
    ],
    Features: [
      "Multiple compartments to slow eating pace",
      "Easy difficulty level ideal for beginners",
      "Made from food-safe, durable plastic materials",
      "Dishwasher safe (top rack)",
      "Anti-slip base for ultimate stability",
      "Available in multiple sizes",
      "Promotes mental enrichment during meals",
    ],
  },
  {
    id: 5,
    name: "Food Enrichment 2-IN-1 Slow Feeder & Lick Pad",
    category: "Slow Feeders",
    price: "16.99",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.jpg",
    images: ["/img/105.jpg"],
    size: ["One size"],
    colors: ["Neutral", "Gold"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Premium 2-in-1 slow feeder and lick pad combination for comprehensive meal enrichment.",
      "Generous surface area accommodates more treats and food for longer entertainment.",
      "Designed for medium to large dogs with higher food requirements.",
      "Helps manage fast eaters and reduces risks associated with gulping air.",
      "Constructed from premium food-safe materials that are built to last.",
      "Versatile design works with wet food, dry kibble, treats, and spreads.",
      "Perfect for daily use or as a special treat during extended alone time.",
    ],
    Features: [
      "Large 2-in-1 design for versatile feeding options",
      "Premium food-grade, BPA-Free construction",
      "Dishwasher safe for easy daily cleaning",
      "Suitable for medium to large dogs",
      "Encourages slower, healthier eating",
      "Multi-surface textures for varied enrichment",
      "Durable and long-lasting materials",
    ],
  },
  {
    id: 6,
    name: "Pawluna LunaPath Petal Bowl Level 1 Easy",
    category: "Interactive Bowls",
    price: "18.99",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.jpg",
    images: ["/img/106.jpg"],
    size: ["S", "M", "L"],
    colors: ["Plum Blur", "Beige"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Part of the Pawluna LunaPath collection, this Level 1 bowl introduces puzzle feeding.",
      "Broad petal pathways create a gentle challenge for beginners learning enrichment feeding.",
      "Level 1 difficulty makes it perfect for puppies, senior dogs, or enrichment beginners.",
      "Encourages natural licking behavior while slowing down eating pace effectively.",
      "Helps reduce anxiety and boredom through engaging mealtime puzzle experience.",
      "Food-safe and BPA-Free materials ensure complete safety for your pet.",
      "Dishwasher safe for convenient cleaning after each use.",
    ],
    Features: [
      "Pawluna LunaPath Level 1 Easy difficulty",
      "Broad petal pathways for a gentle challenge",
      "Food-safe, BPA-Free plastic materials",
      "Promotes slower, healthier eating",
      "Suitable for beginners and all ages",
      "Dishwasher safe for easy cleaning",
      "Available in multiple sizes",
    ],
  },
  {
    id: 7,
    name: "Pawluna LunaPath Pinwheel Bowl Level 1 Easy",
    category: "Interactive Bowls",
    price: "18.99",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.jpg",
    images: ["/img/107.jpg"],
    size: ["S", "M", "L"],
    colors: ["Mocha", "Heather"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Rounded pinwheel pathways from the Pawluna LunaPath collection support easy puzzle feeding.",
      "Four broad curved partitions add interest while slowing down eating.",
      "Level 1 Easy difficulty ensures accessibility for all skill levels.",
      "Compact design perfect for apartments and smaller living spaces.",
      "Encourages natural foraging and licking behaviors in a fun way.",
      "Helps stimulate your dog's mind during every meal.",
      "Durable construction withstands daily use and cleaning.",
    ],
    Features: [
      "Pawluna LunaPath Level 1 Easy difficulty",
      "Four broad curved feeding pathways",
      "Perfect for beginners and puppies",
      "Food-safe, BPA-Free materials",
      "Compact size for easy storage",
      "Dishwasher safe for convenience",
      "Promotes mental stimulation at mealtimes",
    ],
  },
  {
    id: 8,
    name: "Pawluna LunaPath Mosaic Bowl Level 2 Medium",
    category: "Interactive Bowls",
    price: "19.99",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.jpg",
    images: ["/img/108.jpg"],
    size: ["M", "L"],
    colors: ["Brown", "Olive"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Mosaic design from the Pawluna LunaPath collection offers medium difficulty for developing enrichment skills.",
      "Multi-compartment layout creates varied pathways for food to distribute.",
      "Level 2 Medium difficulty provides a balanced challenge for most dogs.",
      "Encourages problem-solving behavior and prolongs feeding time significantly.",
      "Helps reduce behavioral issues by providing adequate mental stimulation.",
      "Suitable for daily use to maintain cognitive engagement.",
      "Premium materials ensure long-lasting durability and safety.",
    ],
    Features: [
      "Pawluna LunaPath Level 2 Medium difficulty",
      "Multi-compartment mosaic design",
      "Balanced challenge for most dogs",
      "Food-safe, BPA-Free construction",
      "Promotes extended feeding sessions",
      "Reduces anxiety and boredom",
      "Dishwasher safe for easy maintenance",
    ],
  },
  {
    id: 9,
    name: "Pawluna LunaPath Orbit Bowl Level 3 Tricky",
    category: "Interactive Bowls",
    price: "19.99",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.jpg",
    images: ["/img/109.jpg"],
    size: ["M", "L"],
    colors: ["Trail Green", "Stone"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Challenging broken-orbit design from the Pawluna LunaPath collection with Level 3 difficulty.",
      "Interwoven curved ridges create a complex puzzle for experienced enrichment users.",
      "Requires more problem-solving skills to navigate food through varied pathways.",
      "Perfect for intelligent breeds that need extra mental stimulation.",
      "Significantly extends feeding time compared to regular bowls.",
      "Helps tire out high-energy dogs mentally during mealtimes.",
      "Durable construction for daily challenging use.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Interwoven orbit paths for maximum challenge",
      "Ideal for intelligent and energetic breeds",
      "Food-safe, BPA-Free materials",
      "Significantly extends feeding time",
      "Provides mental exercise during meals",
      "Dishwasher safe for easy cleaning",
    ],
  },
  {
    id: 10,
    name: "Pawluna LunaPath Galaxy Maze Bowl Level 3 Tricky",
    category: "Interactive Bowls",
    price: "24.99",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.jpg",
    images: ["/img/1010.jpg"],
    size: ["M", "L"],
    colors: ["Black", "Charcoal"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Galaxy-inspired maze design offers an advanced puzzle challenge in the Pawluna LunaPath collection.",
      "Complex maze pathways require advanced problem-solving and coordination.",
      "Level 3 Tricky difficulty designed for experienced enrichment feeders.",
      "Keeps even the most intelligent dogs engaged and mentally stimulated.",
      "Reduces destructive behavior by channeling mental energy into puzzle solving.",
      "Premium food-safe materials ensure safe and durable daily use.",
      "Satisfaction guaranteed with hours of engaging entertainment per meal.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Complex crescent maze pathway design",
      "Ultimate challenge for smart dogs",
      "Food-safe, BPA-Free premium materials",
      "Maximum mental stimulation",
      "Reduces destructive behaviors",
      "Dishwasher safe for convenient cleaning",
    ],
  },
  {
    id: 11,
    name: "Pawluna LunaPath Swirl Bowl Level 3 Tricky",
    category: "Interactive Bowls",
    price: "29.99",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.jpg",
    images: ["/img/1011.jpg"],
    size: ["M", "L"],
    colors: ["Charcoal", "Rose"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Swirl series interactive bowl uses layered curved pathways for a Level 3 Tricky challenge.",
      "Offset channels and rounded pillars create an intricate puzzle for seasoned dogs.",
      "Designed to provide maximum mental enrichment through engaging problem-solving.",
      "Helps satisfy your dog's natural foraging instincts in a safe, controlled way.",
      "Premium materials withstand rigorous daily use and enthusiastic play.",
      "Perfect for rainy days or when outdoor exercise is limited.",
      "Great tool for building confidence in shy or anxious dogs.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Layered curved pathway design",
      "Maximum mental enrichment challenge",
      "Food-safe, BPA-Free durable materials",
      "Satisfies natural foraging instincts",
      "Builds confidence and reduces anxiety",
      "Dishwasher safe for easy maintenance",
    ],
  },
  {
    id: 12,
    name: "Pawluna LunaPath Orbit Bowl with Drift Lid Level 3 Tricky",
    category: "Interactive Bowls",
    price: "29.99",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.jpg",
    images: ["/img/1012.jpg"],
    size: ["L"],
    colors: ["Gunmetal", "Blush"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Advanced Pawluna LunaPath experience with an orbit base and translucent Drift lid.",
      "Two-in-one design doubles the challenge with layered puzzle complexity.",
      "Level 3 Tricky difficulty provides the most challenging enrichment experience.",
      "Premium gunmetal finish combines style with durable functionality.",
      "Modular design allows for customizable difficulty adjustments.",
      "Perfect for experienced dogs who have mastered easier puzzles.",
      "Keeps dogs engaged for extended periods while promoting mental sharpness.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Orbit base with translucent Drift lid",
      "Two-in-one modular puzzle design",
      "Premium gunmetal finish",
      "Customizable difficulty levels",
      "Maximum challenge for expert users",
      "Dishwasher safe for easy cleaning",
    ],
  },
  {
    id: 13,
    name: "Pawluna LunaPath Petal Lick Insert Level 1 Easy",
    category: "Accessories",
    price: "7.99",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.jpg",
    images: ["/img/1013.jpg"],
    size: ["One size"],
    colors: ["Taupe", "Stone"],
    material: "Food-grade silicone, BPA-Free",
    description: [
      "Leaf-path lick insert for the Pawluna LunaPath collection with Level 1 Easy difficulty.",
      "Broad organic grooves provide a gentle licking challenge for beginners.",
      "A useful companion to LunaPath bowls for extended enrichment sessions.",
      "Flexible silicone material can be used flat or curved for variety.",
      "Great for smearing treats or wet food into the textured surface.",
      "Lightweight and portable for enrichment on the go.",
      "Dishwasher safe for convenient cleaning after each use.",
    ],
    Features: [
      "Pawluna LunaPath Level 1 Easy difficulty",
      "Leaf-path textured surface",
      "Flexible silicone construction",
      "Pairs with LunaPath bowls",
      "Food-safe, BPA-Free silicone",
      "Lightweight and travel-friendly",
      "Dishwasher safe for easy cleaning",
    ],
  },
  {
    id: 14,
    name: "Pawluna LunaPath Mosaic Insert Level 2 Medium 50% Recycled Plastic (PCR)",
    category: "Accessories",
    price: "8.99",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.jpg",
    images: ["/img/1014.jpg"],
    size: ["One size"],
    colors: ["Cognac Swirl", "Black"],
    material: "Recycled food-grade plastic (PCR), BPA-Free",
    description: [
      "Mosaic insert made from 50% recycled plastic for more sustainable enrichment.",
      "Multi-zone surface design provides medium difficulty for developing enrichment skills.",
      "Complements LunaPath bowls with additional texture and challenge options.",
      "Environmentally conscious choice without compromising on quality or safety.",
      "Durable construction from recycled materials withstands daily use.",
      "Useful for building up to more challenging LunaPath puzzles gradually.",
      "Easy to clean and maintain for daily enrichment routines.",
    ],
    Features: [
      "Pawluna LunaPath Level 2 Medium difficulty",
      "Made from 50% recycled plastic (PCR)",
      "Eco-friendly sustainable design",
      "Multi-zone textured surface",
      "Complements the LunaPath bowl collection",
      "BPA-Free food-safe materials",
      "Dishwasher safe for easy cleaning",
    ],
  },
  {
    id: 15,
    name: "Pawluna Meadow Snuffle Mat Level 2 Medium Duo Pack",
    category: "Accessories",
    price: "19.99",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.jpg",
    images: ["/img/1015.jpg"],
    size: ["One size"],
    colors: ["Leopard", "Ivory"],
    material: "Soft fleece fabric",
    description: [
      "Layered meadow snuffle mat provides a Level 2 Medium foraging experience.",
      "Duo pack includes two mats for varied enrichment rotation.",
      "Encourages natural sniffing and foraging behaviors in dogs.",
      "Hides treats in the fabric folds for dogs to discover and seek out.",
      "Machine washable for easy and thorough cleaning.",
      "Provides mental stimulation and helps reduce anxiety and boredom.",
      "Perfect for indoor enrichment during bad weather days.",
    ],
    Features: [
      "Pawluna Level 2 Medium difficulty",
      "Layered meadow snuffle mat design",
      "Duo pack with two mats included",
      "Encourages natural foraging behavior",
      "Machine washable fabric",
      "Provides mental stimulation",
      "Great for indoor enrichment activities",
    ],
  },
  {
    id: 16,
    name: "Pawluna Flex Lick & Fetch Disc Level 2 Medium",
    category: "Accessories",
    price: "8.49",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.jpg",
    images: ["/img/1016.jpg"],
    size: ["One size"],
    colors: ["Neutral", "Olive"],
    material: "Food-grade silicone, BPA-Free",
    description: [
      "Innovative lick flying disc combining enrichment with interactive playtime fun.",
      "Level 2 Medium difficulty provides balanced challenge for most dogs.",
      "Can be used as a lick mat or tossed for fetching and chasing games.",
      "Flexible silicone edges are gentle on mouths and easy to grip.",
      "Perfect for combining physical activity with mental enrichment.",
      "Great for outdoor adventures and park enrichment sessions.",
      "Durable construction withstands outdoor use and cleaning.",
    ],
    Features: [
      "Pawluna Level 2 Medium difficulty",
      "Dual-purpose lick mat and flying disc",
      "Flexible silicone construction",
      "Combines play with enrichment",
      "Great for indoor and outdoor use",
      "Food-safe, BPA-Free materials",
      "Easy to clean after playtime",
    ],
  },
  {
    id: 17,
    name: "Pawluna LunaPath Ripple Lick Insert Level 1 Easy",
    category: "Accessories",
    price: "7.99",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.jpg",
    images: ["/img/1017.jpg"],
    size: ["One size"],
    colors: ["Midnight Blue", "White"],
    material: "Food-grade silicone, BPA-Free",
    description: [
      "Ripple lick insert in midnight blue offers a Level 1 Easy challenge.",
      "Four broad wave fans create gentle texture for beginner licking enrichment.",
      "A friendly introduction to the LunaPath collection for new enrichment users.",
      "Calming blue color adds visual appeal to your enrichment routine.",
      "Flexible silicone construction can be used flat or shaped as needed.",
      "Ideal for smearing with treats, peanut butter, or wet food.",
      "Compact design perfect for travel and on-the-go enrichment.",
    ],
    Features: [
      "Pawluna LunaPath Level 1 Easy difficulty",
      "Broad ripple-fan textured pattern",
      "Elegant midnight blue color",
      "Flexible silicone construction",
      "Beginner-friendly enrichment accessory",
      "Food-safe, BPA-Free materials",
      "Dishwasher safe for easy cleaning",
    ],
  },
  {
    id: 18,
    name: "Pawluna LunaPath Comet Maze Disc Level 3 Tricky",
    category: "Accessories",
    price: "9.99",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.jpg",
    images: ["/img/1018.jpg"],
    size: ["One size"],
    colors: ["Mulberry", "Sand"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Comet-path maze disc provides a Level 3 Tricky challenge for experienced enrichment users.",
      "Complex pathways require advanced problem-solving skills and coordination.",
      "Ultimate test for intelligent dogs who have mastered easier puzzles.",
      "Can be used as a standalone enrichment toy or with LunaPath bowls.",
      "Durable construction withstands enthusiastic play and daily use.",
      "Keeps dogs engaged for extended periods with maximum mental stimulation.",
      "Perfect reward toy for training sessions and trick practice.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Comet maze pathway design",
      "Ultimate mental enrichment challenge",
      "Advanced problem-solving toy",
      "Food-safe, BPA-Free materials",
      "Great for training rewards",
      "Dishwasher safe for easy cleaning",
    ],
  },
  {
    id: 19,
    name: "Pawluna LunaPath Frosted Drift Lid Level 3 Tricky",
    category: "Accessories",
    price: "11.99",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.jpg",
    images: ["/img/1019.jpg"],
    size: ["One size"],
    colors: ["Gunmetal", "Ivory"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Frosted Drift lid offers a Level 3 Tricky challenge for compatible LunaPath bowls.",
      "Twisting design creates complex puzzle when placed over compatible bowls.",
      "Premium frosted finish adds elegance to your enrichment collection.",
      "Transforms any compatible bowl into a more challenging puzzle feeder.",
      "Modular design allows for customizable difficulty progression.",
      "Perfect for dogs ready to advance beyond Level 2 challenges.",
      "Durable construction for long-lasting enrichment enjoyment.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Frosted twister lid design",
      "Compatible with selected LunaPath bowls",
      "Premium frosted finish",
      "Modular puzzle accessory",
      "Advanced difficulty challenge",
      "Food-safe, BPA-Free materials",
    ],
  },
  {
    id: 20,
    name: "Pawluna LunaPath Night Orbit Insert Level 3 Tricky",
    category: "Accessories",
    price: "9.99",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.jpg",
    images: ["/img/1020.jpg"],
    size: ["One size"],
    colors: ["Black with Gunmetal", "Blush"],
    material: "Food-grade plastic, BPA-Free",
    description: [
      "Night Orbit insert providing a Level 3 Tricky enrichment challenge.",
      "Deep spiral ridges create the most complex licking and foraging challenge.",
      "Premium black and gunmetal finish offers sophisticated style.",
      "Standalone insert or companion to the LunaPath bowl collection.",
      "Designed for dogs who need maximum mental stimulation.",
      "Helps reduce destructive behaviors through engaging puzzle play.",
      "Professional-grade construction for daily demanding use.",
    ],
    Features: [
      "Pawluna LunaPath Level 3 Tricky difficulty",
      "Broken-orbit ridge design",
      "Premium black and gunmetal finish",
      "Maximum difficulty challenge",
      "Standalone or companion accessory",
      "Reduces destructive behaviors",
      "Food-safe, BPA-Free materials",
    ],
  },
];

export default productData;
